import { render, staticRenderFns } from "./TemplateStepFormulario.vue?vue&type=template&id=72949c2f&scoped=true"
import script from "./TemplateStepFormulario.vue?vue&type=script&lang=js"
export * from "./TemplateStepFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72949c2f",
  null
  
)

export default component.exports